import { useMemo, useState } from 'react';
import BugReportContext from './BugReportContext';
import BugReportModal from '@components/BugReportProvider/components/BugReportModal/BugReportModal';
import ScreenshotProvider from '@components/ScreenshotProvider/ScreenshotProvider';

type Props = {
  children: React.ReactNode;
};

const BugReportProvider = ({ children }: Props) => {
  const [showBugReportModal, setShowBugReportModal] = useState(false);

  const value = useMemo(
    () => ({
      createBugReport: () => setShowBugReportModal(true),
    }),
    [setShowBugReportModal],
  );

  return (
    <ScreenshotProvider>
      <BugReportContext.Provider value={value}>
        {children}
      </BugReportContext.Provider>
      {showBugReportModal && <BugReportModal setOpen={setShowBugReportModal} />}
    </ScreenshotProvider>
  );
};

export default BugReportProvider;
